/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingDtoSearchResponse } from '../../models/setting-dto-search-response';

export interface SearchSettings$Params {
  SearchText?: string;
  Top?: number;
  Skip?: number;
  SortBy?: string;
  SortDescending?: boolean;
}

export function searchSettings(http: HttpClient, rootUrl: string, params?: SearchSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingDtoSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchSettings.PATH, 'get');
  if (params) {
    rb.query('SearchText', params.SearchText, {});
    rb.query('Top', params.Top, {});
    rb.query('Skip', params.Skip, {});
    rb.query('SortBy', params.SortBy, {});
    rb.query('SortDescending', params.SortDescending, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettingDtoSearchResponse>;
    })
  );
}

searchSettings.PATH = '/api/settings';
